import { render } from "./PopulateQuestionsModal.vue?vue&type=template&id=e4f83e3e&scoped=true"
import script from "./PopulateQuestionsModal.vue?vue&type=script&lang=js"
export * from "./PopulateQuestionsModal.vue?vue&type=script&lang=js"

import "./PopulateQuestionsModal.vue?vue&type=style&index=0&id=e4f83e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4f83e3e"]])

export default __exports__